<template>
    <div
        class="flex-1 flex flex-col min-h-0 bg-white dark:bg-neutral-900 border-r border-gray-200 dark:border-neutral-700"
    >
        <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <div class="flex items-center flex-shrink-0 px-4">
                <AppLogo size="md" />
            </div>

            <nav class="mt-8 flex-1 px-2 space-y-1">
                <router-link
                    v-for="item in navigation"
                    :key="item.name"
                    :to="item.href"
                    :class="[
                        $route.path === item.href
                            ? $route.path === '/billing'
                                ? 'border-2 border-primary'
                                : 'bg-orange-600 text-white'
                            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-neutral-800 dark:hover:text-white',
                        'group flex items-center px-2 py-2 text-sm font-medium rounded-md',
                    ]"
                >
                    <section
                        :class="[
                            item.href == '/billing' ? 'p-2' : '',
                            'flex items-center ',
                        ]"
                    >
                        <i
                            :class="[
                                item.icon,
                                $route.path === item.href
                                    ? 'text-white'
                                    : 'text-gray-400 group-hover:text-gray-500 dark:group-hover:text-gray-300',
                                'mr-3 flex-shrink-0 text-lg',
                            ]"
                        ></i>
                        <div>
                            <span class="flex items-center">
                                {{ item.name }}
                            </span>
                            <span
                                class="hidden md:flex md:text-xs text-primary dark:text-primary-dark group-hover:text-primary-dark"
                            >
                                {{ item.description }}
                            </span>
                        </div>
                    </section>
                </router-link>
            </nav>
        </div>

        <!-- Close button for mobile -->
        <div
            v-if="$slots.close"
            class="flex-shrink-0 flex border-t border-gray-200 dark:border-neutral-700 p-4 lg:hidden"
        >
            <button
                @click="$emit('close')"
                class="flex-shrink-0 w-full group block"
            >
                <div class="flex items-center">
                    <div>
                        <i class="pi pi-times text-gray-400 text-lg"></i>
                    </div>
                    <div class="ml-3">
                        <p
                            class="text-sm font-medium text-gray-700 dark:text-gray-300"
                        >
                            Fechar
                        </p>
                    </div>
                </div>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import AppLogo from "@/components/ui/AppLogo.vue";

defineEmits<{
    close: [];
}>();

const navigation = [
    {
        name: "Billing",
        href: "/billing",
        description: "Atualize seu plano",
        icon: "pi pi-dollar",
    },

    {
        name: "Dashboard",
        href: "/dashboard",
        icon: "pi pi-home",
    },
    {
        name: "Scripts",
        href: "/scripts",
        icon: "pi pi-file-edit",
    },
    {
        name: "Licenças",
        href: "/licenses",
        icon: "pi pi-key",
    },
    {
        name: "Snapshots",
        href: "/snapshots",
        icon: "pi pi-camera",
    },
    {
        name: "Access Keys",
        href: "/access-keys",
        icon: "pi pi-shield",
    },
    {
        name: "Documentação",
        href: "/docs",
        icon: "pi pi-book",
    },
    {
        name: "Configurações",
        href: "/settings",
        icon: "pi pi-cog",
    },
];
</script>
